export default [
  'text-m-regular',
]
